const ADMIN_FEATURE_KEYS = new Set([
  'dashboard.overview',
  'analytics.view',
  'health.view',
  'commerce.afrika_shop',
  'communications.hq',
  'communications.hq.manage',
  'communications.whatsapp.inbox',
  'communications.whatsapp.backend',
  'meta.catalog',
  'meta.publishing',
  'content.articles',
  'content.mixtapes',
  'content.radio',
  'content.games',
  'content.featured',
  'site.manage',
  'events.manage',
  'integrations.manage',
  'marketing.manage',
  'monetization.manage',
  'users.manage',
  'creators.manage',
  'system.manage',
]);

export const ADMIN_WORKSPACE_ROLES = new Set([
  'super_admin',
  'admin',
  'manager',
  'editor',
  'moderator',
  'feature_tester',
]);

const FEATURE_DEPENDENCIES = {
  'communications.hq.manage': ['communications.hq'],
  'communications.whatsapp.backend': ['communications.whatsapp.inbox'],
  'meta.catalog': ['communications.whatsapp.inbox', 'communications.whatsapp.backend'],
  'meta.publishing': ['communications.whatsapp.inbox', 'communications.whatsapp.backend', 'meta.catalog'],
};

const hasCreatorIdentity = (user) => Boolean(
  user?.is_creator || user?.creator_id || user?.creator_status,
);

export const canEnterAdminWorkspace = (user) => {
  const role = String(user?.role || '').toLowerCase();
  if (!ADMIN_WORKSPACE_ROLES.has(role) || !user?.admin_access?.allowed) return false;
  // The owner remains authoritative. Every other Creator account stays in
  // Creator Workspace even if stale staff flags survived an earlier role.
  return role === 'super_admin' || !hasCreatorIdentity(user);
};

export const expandAdminFeatures = (selected = []) => {
  const expanded = [...new Set(selected.filter((key) => ADMIN_FEATURE_KEYS.has(key)))];
  if (expanded.length > 0 && !expanded.includes('dashboard.overview')) {
    expanded.unshift('dashboard.overview');
  }
  let changed = true;
  while (changed) {
    changed = false;
    [...expanded].forEach((key) => {
      (FEATURE_DEPENDENCIES[key] || []).forEach((dependency) => {
        if (!expanded.includes(dependency)) {
          expanded.push(dependency);
          changed = true;
        }
      });
    });
  }
  return expanded;
};

const accessFeatures = (adminAccess = {}) => {
  const selected = adminAccess.features || [];
  return new Set(selected.includes('*') ? ['*'] : expandAdminFeatures(selected));
};

export const canAccessFeature = (adminAccess, feature) => {
  const features = accessFeatures(adminAccess);
  return Boolean(adminAccess?.allowed && (adminAccess.full_access || features.has('*') || features.has(feature)));
};
